/**
 * Constants and types for BlueYonder integration
 */

import * as z from "zod/v4";

// Log stamp for consistent logging across the application
export const BLUE_YONDER_LOG_STAMP = "- BlueYonder Integration -";

// BlueYonder locations URL for customers to find drop-off points
export const BLUE_YONDER_LOCATIONS_URL = "https://www.blueyonder.com/locations";

// BlueYonder webhook event types for processing
export enum WebhookEventType {
  DROPPED_OFF = "RETURN_EVENT-DROPPED_OFF",
  DESPATCHED_FROM_PUDO = "RETURN_EVENT-DESPATCHED_FROM_PUDO", // PUDO = Pickup & Dropoff center
  ARRIVED_AT_DESTINATION = "RETURN_EVENT-ARRIVED_AT_DESTINATION",
}
export const blueYonderLocationSchema = z.object({
  blueyonderLocationId: z.string(),
  locationName: z.string(),
});

export const blueYonderIntegrationInputSchema = z.object({
  retailerCompanyId: z.string(),
  locations: z.array(blueYonderLocationSchema).optional(),
  processingEvent: z.enum(WebhookEventType).optional(),
  testMode: z.boolean().optional(),
  radiusMiles: z.number().min(1).optional(),
  upcharge: z.number().optional(),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  locationsText: z.string().optional(),
});

export type BlueYonderIntegrationInput = z.infer<
  typeof blueYonderIntegrationInputSchema
>;
